var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UkrTreasuresCreateUser',{attrs:{"UT":_vm.UT,"shippingMethods":_vm.shippingMethods},on:{"save":function($event){return _vm.save({edit: false})}}})
}
var staticRenderFns = []

export { render, staticRenderFns }